import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import ProductCard from '@nmx/template/dist/componentLibrary/modules/ProductCard';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// styles
import {
  ColStyled,
  RowStyled,
  TypographyStyled,
} from './styles';

const ITEMS = [
  {
    cardId: 'retirement-planning-link',
    cardHeading: 'Retirement planning',
    linkUrl: '/retirement-planning/',
  },
  {
    cardId: 'college-savings-plans-link',
    cardHeading: 'College savings planning',
    linkUrl: '/college-savings-plans/',
  },
  {
    cardId: 'business-services-link',
    cardHeading: 'Business planning',
    linkUrl: '/financial-planning/business-services/',
  },
  {
    cardId: 'special-needs-planning-link',
    cardHeading: 'Special needs planning',
    linkUrl: '/financial-planning/special-needs-planning/',
  },
  {
    cardId: 'estate-planning-link',
    cardHeading: 'Estate planning',
    linkUrl: '/financial-planning/estate-planning/',
  },
  {
    cardId: 'long-term-care-planning-link',
    cardHeading: (<>Long&#45;term care planning</>),
    linkUrl: '/long-term-care-planning/',
  },
];

export default () => (
  <SectionContainer
    id='financial-planning-product-callout-grouping'
    moduleName='product-callout-grouping-module'
    moduleVariation='B'>
    <Row align='center'>
      <Col large={8}>
        <Typography
          align='center'
          component='h2'>
          You know what you want from <WidowBlock>your money.</WidowBlock>
          <TypographyStyled
            component='span'
            block
            disableBottomPadding>
            Let&#39;s plan for it.
          </TypographyStyled>
        </Typography>
        <Typography nextElement='graphic'>
          Your financial plan is based on your priorities. As they change over time, your advisor will work with you to shift strategies to keep you on track to what matters most to you. So you can do more and worry less along the way. Here are some of the specialized planning services we offer:
        </Typography>
      </Col>
    </Row>
    <RowStyled align='left'>
      {ITEMS.map((item, index) => (
        <ColStyled
          key={`col-${item.cardId}`}
          medium={6}
          large={4}
          disableBottomPadding={(index + 1) === ITEMS.length} // disable bottom padding on last item
        >
          <ProductCard
            cardId={`financial-planning-product-callout-card-${item.cardId}`}
            cardHeading={item.cardHeading}
            linkUrl={item.linkUrl}
            ariaLabel={item.ariaLabel}
            backgroundVariant='lightB'
            condensed
            fixHeight
          />
        </ColStyled>
      ))}
    </RowStyled>
  </SectionContainer>
);
